export default "__VITE_ASSET__B_P78de7__"